module.exports = __webpack_public_path__ + "static/media/img_bg_case.eefa048a.png";